/**
 * Buddy System: you pick people up faster.
 *
 * The one perk in the tree that does nothing at all alone, and it stays that way. A game where
 * every system works solo still gets to have one node that is a reason to bring somebody.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const BUDDY_SYSTEM = {
  id: 'buddySystem',
  branch: 'survival',
  tier: 2,
  title: 'Buddy System',
  blurb: 'Never enter a contaminated zone alone. Never leave one alone either.',
  maxRanks: 3,
  minLevel: 9,
  requires: ['ironConstitution'],
  statGrants: {},
  effects: [{ field: 'reviveSeconds', perRank: -0.09, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
